import { ChangeDetectionStrategy, Component } from '@angular/core';

import { FacilitiesTable } from '@pages/dashboard/portfolio/general-overview/components/facilities-table/facilities-table.component';
import { PortfolioKpis } from '@pages/dashboard/portfolio/general-overview/components/portfolio-kpis/portfolio-kpis.component';
import { StoryStep } from '@pages/dashboard/portfolio/general-overview/components/story-step/story-step.component';

/** Los cinco pasos del tab, en orden de lectura (LEN-2663, LEN-2931). */
export const PORTFOLIO_STEPS = [
  {
    n: 1,
    title: $localize`Size`,
    question: $localize`How big is the portfolio and how much of it is yours?`,
  },
  {
    n: 2,
    title: $localize`Composition`,
    question: $localize`What is it made of, where do you sit in each structure and who services it?`,
  },
  {
    n: 3,
    title: $localize`Who you lend to`,
    question: $localize`Which business models, stages and verticals are you exposed to?`,
  },
  {
    n: 4,
    title: $localize`Where & industry`,
    question: $localize`Where are the originators based and what industry are they in?`,
  },
  {
    n: 5,
    title: $localize`Facility detail`,
    question: $localize`Every number above, facility by facility`,
  },
] as const;

/**
 * El tab **Portfolio** del Overview: la composición del portafolio leída de lo
 * macro a lo micro.
 *
 * Acá vive el armazón -- los cinco pasos en su orden -- y el paso 1 ya
 * llenado (LEN-2848) y el 5 con su tabla (LEN-2849). Los pasos 2 a 4 llegan
 * en LEN-2664.
 *
 * **Sin selector de corte, y no es un olvido.** El dato que este tab muestra
 * es maestro -- de Companies y de la facility-- y no cambia con el corte
 * elegido. Un control que no mueve nada enseña a desconfiar de los controles,
 * así que el selector vive sólo en Collateral, donde sí manda. La fecha del
 * dato va arriba, en la barra, como `Last updated`.
 */
@Component({
  selector: 'portfolio-tab',
  standalone: true,
  imports: [StoryStep, PortfolioKpis, FacilitiesTable],
  templateUrl: './portfolio.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PortfolioTab {
  readonly steps = PORTFOLIO_STEPS;
}
